import RequestQueue from 'shared/clients/RequestQueue';

const sicSaveQueue = new RequestQueue('sicSaveQueue');

export { sicSaveQueue };
